import { atom } from "jotai";

export const selectedUserIdAtom = atom<string | null>(null);
